module.exports = __webpack_public_path__ + "img/newlogo5.9702249d.png";